import React from "react";
import {
  getErrorMessage,
  getErrorTitle,
  isFulfilledError,
  isClosedError,
  isExpiredError,
  isPaidError,
  isSessionLostError
} from "../../utils/paymentLinkErrorHandler";
import { AlertCircle, XCircle, Clock, CheckCircle, Users, WifiOff } from "lucide-react";

const ErrorTransactionNotFound = ({ errorCode, message }) => {

  // Use error handler utility to get appropriate message
  const displayTitle = errorCode ? getErrorTitle(errorCode) : "Transaksi Tidak Ditemukan";
  const displayMessage = errorCode
    ? getErrorMessage(errorCode)
    : message || "Kami tidak dapat menemukan transaksi yang Anda cari. Mungkin sudah ditutup, penuh, atau kadaluarsa.";

  // Determine icon and color based on error type
  const getErrorConfig = () => {
    if (isFulfilledError(errorCode)) {
      return {
        icon: <Users size={72} strokeWidth={1.5} />,
        iconColor: "text-orange-500",
        titleColor: "text-orange-700",
        bgColor: "bg-orange-50",
        borderColor: "border-orange-200",
        textColor: "text-orange-800"
      };
    }
    if (isClosedError(errorCode)) {
      return {
        icon: <XCircle size={72} strokeWidth={1.5} />,
        iconColor: "text-gray-500",
        titleColor: "text-gray-700",
        bgColor: "bg-gray-50",
        borderColor: "border-gray-200",
        textColor: "text-gray-800"
      };
    }
    if (isExpiredError(errorCode)) {
      return {
        icon: <Clock size={72} strokeWidth={1.5} />,
        iconColor: "text-yellow-500",
        titleColor: "text-yellow-700",
        bgColor: "bg-yellow-50",
        borderColor: "border-yellow-200",
        textColor: "text-yellow-800"
      };
    }
    if (isPaidError(errorCode)) {
      return {
        icon: <CheckCircle size={72} strokeWidth={1.5} />,
        iconColor: "text-green-500",
        titleColor: "text-green-700",
        bgColor: "bg-green-50",
        borderColor: "border-green-200",
        textColor: "text-green-800"
      };
    }
    if (isSessionLostError(errorCode)) {
      return {
        icon: <WifiOff size={72} strokeWidth={1.5} />,
        iconColor: "text-blue-500",
        titleColor: "text-blue-700",
        bgColor: "bg-blue-50",
        borderColor: "border-blue-200",
        textColor: "text-blue-800"
      };
    }
    return {
      icon: <AlertCircle size={72} strokeWidth={1.5} />,
      iconColor: "text-red-500",
      titleColor: "text-red-700",
      bgColor: "bg-red-50",
      borderColor: "border-red-200",
      textColor: "text-red-800"
    };
  };

  const config = getErrorConfig();

  // Additional info for specific error types
  const getAdditionalInfo = () => {
    if (isFulfilledError(errorCode)) {
      return (
        <div className={`mt-6 p-6 ${config.bgColor} rounded-2xl shadow-sm`}>
          <p className={`text-sm ${config.textColor} leading-relaxed`}>
            <span className="font-semibold block mb-2">Apa artinya?</span>
            Payment link ini telah mencapai batas maksimum jumlah transaksi yang diizinkan.
            Silakan hubungi merchant untuk mendapatkan payment link baru.
          </p>
        </div>
      );
    }
    if (isClosedError(errorCode)) {
      return (
        <div className={`mt-6 p-6 ${config.bgColor} rounded-2xl shadow-sm`}>
          <p className={`text-sm ${config.textColor} leading-relaxed`}>
            <span className="font-semibold block mb-2">Apa artinya?</span>
            Payment link ini telah ditutup oleh merchant dan tidak lagi menerima pembayaran.
          </p>
        </div>
      );
    }
    if (isSessionLostError(errorCode)) {
      return (
        <div className={`mt-6 p-6 ${config.bgColor} rounded-2xl shadow-sm`}>
          <p className={`text-sm ${config.textColor} leading-relaxed`}>
            <span className="font-semibold block mb-2">Apa yang harus dilakukan?</span>
            Silakan akses kembali payment link dari awal atau refresh halaman untuk memulai sesi baru.
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="min-h-screen bg-heropatterns flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 px-4 py-8">
      <div className="w-full max-w-lg">
        {/* Main Card - mengikuti style card dari payment method */}
        <div className=" rounded-xl shadow-sm p-8">
          {/* Icon Section */}
          <div className="flex justify-center mb-6">
            <div className={`inline-flex ${config.iconColor}`}>
              {config.icon}
            </div>
          </div>

          {/* Title */}
          <h1 className={`text-2xl font-bold ${config.titleColor} text-center mb-3 leading-tight`}>
            {displayTitle}
          </h1>

          {/* Message */}
          <p className="text-gray-600 text-center text-sm leading-relaxed">
            {displayMessage}
          </p>

          {/* Additional Info Section */}
          {getAdditionalInfo() && (
            <div className="mt-6">
              {getAdditionalInfo()}
            </div>
          )}
        </div>

        {/* Support Text */}
        <p className="text-center text-gray-500 text-xs mt-4">
          Butuh bantuan? Hubungi customer support merchant
        </p>
      </div>
    </div>
  );
};

export default ErrorTransactionNotFound;
